import React, { useEffect, useState } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import EmployeeImg from "../assets/storeNew1.png";
import FilterIcon from "../assets/filterIcon.png";
import actionSetting from "../assets/actionSetting.svg";
import installIcon from "../assets/installIcon.svg";
import Search2 from "../assets/search.png";
import { Link } from "react-router-dom";
import Editred from "../assets/editred.svg";
import { Pagination } from "react-bootstrap";
import {
  Calendar,
  ChevronDown,
  Edit,
  Filter,
  Plus,
  Search,
  Shield,
  Activity,
} from "lucide-react";
import GreyArrow from "../assets/greyLeftAr.png";
import { Modal, Button } from "react-bootstrap";
import {
  server_post_data,
  action_resturant,
  new_restaurant_install,
  get_all_resturant,
  APL_LINK,
  get_restaurant_access_control_list,
  get_restaurant_security_logs,
  toggle_restaurant_access_control,
} from "../ServiceConnection/serviceconnection.js";
import {
  computeTodayDate,
  handleAphabetsChange,
  handleError,
  inputdateformateChange,
  formatTimeintotwodigit,
  handleLinkClick,
  handleEmailChange,
  handleNumbersChange,
  handleIaphabetnumberChange,
  formatDateStringdot,
  formatTimeFormatcustom,
  computeplussevendays,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import {
  ViewStaffPagesText,
  options_search,
  GuestManagementPageText,
} from "./../CommonJquery/WebsiteText";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function RestaurantSetup() {
  let flag = "1";
  let formattedSevenDaysAgo = computeplussevendays();
  let formattedToday = computeTodayDate();

  // Set initial state using useState hook
  // Convert string dates to Date objects for DatePicker
  const convertToDate = (dateString) => {
    if (!dateString) return new Date();
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  // Set initial state using useState hook with Date objects
  const [startDate, setStartDate] = useState(
    convertToDate(computeplussevendays()),
  );
  const [endDate, setEndDate] = useState(convertToDate(computeTodayDate()));
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedValue2, setSelectedValue2] = useState("0");
  const [editStaffData, seteditStaffData] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  const [StaffImageLinkData, setsStaffImageLinkData] = useState("");
  const [selectedValue, setSelectedValue] = useState("Name");
  const [searchfilter, setSearchFilter] = useState("");
  const [SelectedData, setSelectedData] = useState([]);
  const [ProductOptions, setProductOptions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [filterOption, setFilterOption] = useState("");

  // New states for Access Control & Security Logs
  const [activeTab, setActiveTab] = useState("restaurants"); // restaurants, access_control, security_logs
  const [accessControlList, setAccessControlList] = useState([]);
  const [securityLogs, setSecurityLogs] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [accessStats, setAccessStats] = useState({
    total_devices: 0,
    total_ips: 0,
    active_count: 0,
    inactive_count: 0,
  });
  // Format Date object to 'YYYY-MM-DD' string format
  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [logStats, setLogStats] = useState({
    total_logs: 0,
    allowed_count: 0,
    blocked_count: 0,
  });
  const [accessTypeFilter, setAccessTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [logDateRange, setLogDateRange] = useState({
    start: formatDate(convertToDate(computeplussevendays())),
    end: formatDate(convertToDate(computeTodayDate())),
  });

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(formatDate(startDate), formatDate(endDate), flag, call_id);
  }, []);

  const handleClose = () => {
    setModalShow(false);
  };

  const handleShow = (data_call) => {
    setSelectedData(data_call);
    setModalShow(true);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_resturant, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          Response.data.message.data_restaurant.forEach((subObj) => {
            if (subObj.active_status === 1) {
              subObj.activedata = "Active";
            } else {
              subObj.activedata = "Deactive";
            }
          });
          setSelectedRestaurant(null);
          seteditStaffData(Response.data.message.data_restaurant);
          setfilteredData(Response.data.message.data_restaurant);
          setProductOptions(Response.data.message.data_restaurant_options);
          setsStaffImageLinkData(
            APL_LINK + Response.data.message.data_restaurant_image,
          );
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // ================ NEW FUNCTIONS FOR ACCESS CONTROL & SECURITY LOGS ================

  // Fetch Access Control List
  const fetchAccessControlList = async (restaurant) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("default_restaurant_id", restaurant.primary_id);
    fd.append("admin_id", "0"); // Replace with actual admin_id from context
    fd.append("access_type", accessTypeFilter);
    fd.append("is_active", statusFilter);

    await server_post_data(
      get_restaurant_access_control_list,
      fd,
      restaurant.database_name,
    )
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setAccessControlList(Response.data.message.access_list);
          setAccessStats({
            total_devices: Response.data.message.total_devices,
            total_ips: Response.data.message.total_ips,
            active_count: Response.data.message.active_count,
            inactive_count: Response.data.message.inactive_count,
          });
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Create a max date for date picker (today)
  const today = new Date();

  // Custom styles for the date picker to match your design
  const datePickerCustomStyles = {
    datePickerContainer: {
      position: "relative",
      width: "100%",
    },
    datePickerInput: {
      width: "100%",
      padding: "0.375rem 0.75rem",
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#495057",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #ced4da",
      borderRadius: "0.25rem",
      transition:
        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    },
  };

  // Fetch Security Logs
  const fetchSecurityLogs = async (restaurant) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("default_restaurant_id", restaurant.primary_id);
    fd.append("admin_id", "0"); // Replace with actual admin_id from context
    fd.append("status_filter", statusFilter);
    fd.append("access_type", accessTypeFilter);
    fd.append("start_date", logDateRange.start);
    fd.append("end_date", logDateRange.end);
    fd.append("limit", "100");

    await server_post_data(
      get_restaurant_security_logs,
      fd,
      restaurant.database_name,
    )
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setSecurityLogs(Response.data.message.logs);
          setLogStats({
            total_logs: Response.data.message.total_logs,
            allowed_count: Response.data.message.allowed_count,
            blocked_count: Response.data.message.blocked_count,
          });
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Toggle Access Control Status
  const toggleAccessStatus = async (accessControl) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("default_restaurant_id", selectedRestaurant.primary_id);
    fd.append("admin_id", "0"); // Replace with actual admin_id from context
    fd.append("access_control_id", accessControl.primary_id);
    fd.append("is_active", accessControl.is_active === 1 ? 0 : 1);

    await server_post_data(
      toggle_restaurant_access_control,
      fd,
      selectedRestaurant.database_name,
    )
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess(Response.data.message);
          fetchAccessControlList(selectedRestaurant);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // View Access Control for a restaurant
  const viewAccessControl = (restaurant) => {
    setSelectedRestaurant(restaurant);
    setActiveTab("access_control");
    fetchAccessControlList(restaurant);
  };

  // View Security Logs for a restaurant
  const viewSecurityLogs = (restaurant) => {
    setSelectedRestaurant(restaurant);
    setActiveTab("security_logs");
    fetchSecurityLogs(restaurant);
  };

  // ================ END NEW FUNCTIONS ================

  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleSelect2 = (event) => {
    setSelectedValue2(event.target.value);
  };

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(formatDate(startDate), formatDate(endDate), flag, call_id);
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };

  const [showModal, setShowModal] = useState(false);
  const [clickedButton, setClickedButton] = useState(null);
  const [selectedGuestIndex, setSelectedGuestIndex] = useState(1);

  const openModal = (guestName, index, flag) => {
    let tesr_show = " Not ";
    if (guestName.active_status === 0) {
      tesr_show = "";
    }
    tesr_show = tesr_show + "  as Active ";
    setSelectedData(guestName);
    if (flag === 1) {
      setShowModal(true);
    } else {
      setShowModal2(true);
    }

    setClickedButton(guestName.restaurant_name + tesr_show);
    setSelectedGuestIndex(index);
  };

  const confirmVIP = (index) => {
    let allow_access_data = "0";
    if (SelectedData.active_status === 0) {
      allow_access_data = "1";
    }

    master_data_action_update(SelectedData, allow_access_data, 1);
  };

  const confirmVIP2 = (index, flag) => {
    let allow_access_data = selectedValue2;

    master_data_action_update(SelectedData, allow_access_data, flag);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModal2(false);
  };

  const master_data_action_update = async (
    call_id,
    allow_access_data,
    flag_data,
  ) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("id_for_delete", call_id.primary_id);
    fd.append("flag_for", flag_data);
    fd.append("for_status_final", allow_access_data);
    await server_post_data(action_resturant, fd,call_id.database_name)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(formatDate(startDate), formatDate(endDate), "1", "0");
          handleSuccess(Response.data.message);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    setShowModal(false);
    setShowModal2(false);
  };

  const InstallRestaurant = async (primary_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("id_for", primary_id);
    await server_post_data(new_restaurant_install, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(formatDate(startDate), formatDate(endDate), "1", "0");
          handleSuccess(Response.data.message);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="dashboard">
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p>Restaurant Setup</p>
                <img src={GreyArrow} alt="Barley's Dashboard" />
              </div>
            </div>

            {/* Tab Navigation */}
            <div className="tabNavigation pageCntn_head" style={{ marginBottom: "20px" }}>
              <button
                className={`tabButton ${activeTab === "restaurants" ? "active" : ""}`}
                onClick={() => setActiveTab("restaurants")}
                style={{
                  padding: "10px 20px",
                  marginRight: "10px",
                  marginLeft: "10px",
                  border: "none",
                  borderRadius: "5px",
                  backgroundColor:
                    activeTab === "restaurants" ? "#4CAF50" : "#f1f1f1",
                  color: activeTab === "restaurants" ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              >
                Restaurants
              </button>
              {selectedRestaurant && (
                <>
                  <button
                    className={`tabButton ${activeTab === "access_control" ? "active" : ""}`}
                    onClick={() => viewAccessControl(selectedRestaurant)}
                    style={{
                      padding: "10px 20px",
                      marginRight: "10px",
                      border: "none",
                      borderRadius: "5px",
                      backgroundColor:
                        activeTab === "access_control" ? "#4CAF50" : "#f1f1f1",
                      color: activeTab === "access_control" ? "#fff" : "#000",
                      cursor: "pointer",
                    }}
                  >
                    <Shield size={16} style={{ marginRight: "5px" }} />
                    Access Control - {selectedRestaurant.restaurant_name}
                  </button>
                  <button
                    className={`tabButton ${activeTab === "security_logs" ? "active" : ""}`}
                    onClick={() => viewSecurityLogs(selectedRestaurant)}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      backgroundColor:
                        activeTab === "security_logs" ? "#4CAF50" : "#f1f1f1",
                      color: activeTab === "security_logs" ? "#fff" : "#000",
                      cursor: "pointer",
                    }}
                  >
                    <Activity size={16} style={{ marginRight: "5px" }} />
                    Security Logs - {selectedRestaurant.restaurant_name}
                  </button>
                </>
              )}
            </div>

            {/* RESTAURANTS TAB */}
            {activeTab === "restaurants" && (
              <div className="page_body">
                <div className="viewStaff_head">
                  <div className="crm-filters-section">
                    <div className="crm-filter-group filter_section">
                      <label>Filter</label>
                      <div className="date-input">
                        <select
                          value={filterOption}
                          onChange={(e) => setFilterOption(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "0.5rem",
                            borderRadius: "4px",
                          }}
                          className="form-select"
                        >
                          <option value="" disabled>
                            Select Option
                          </option>
                          <option value="today">Today</option>
                          <option value="this_week">This Week</option>
                          <option value="this_month">This Month</option>
                          <option value="this_year">This Year</option>
                          <option value="custom">Custom</option>
                        </select>
                      </div>
                    </div>
                    {filterOption === "custom" && (
                      <>
                        <div className="crm-filter-group">
                          <label className="">
                            {" "}
                            {GuestManagementPageText.Start_Date}
                          </label>
                          <div className="crm-date-input">
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              maxDate={today}
                              // showYearDropdown
                              // showMonthDropdown
                              // dropdownMode="select"
                              // className="form-control input_field_custom4"
                              dateFormat="yyyy-MM-dd"
                              placeholderText={GuestManagementPageText.D_O_B}
                              style={datePickerCustomStyles.datePickerInput}
                              className="crm-form-control"
                            />
                            <Calendar className="crm-date-icon" size={16} />
                          </div>
                        </div>
                        <div className="crm-form-group1">
                          <label className="mb-2">End Date</label>
                          <div className="crm-date-input">
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              maxDate={today}
                              className="crm-form-control"
                              dateFormat="yyyy-MM-dd"
                              placeholderText={GuestManagementPageText.D_O_B}
                              style={datePickerCustomStyles.datePickerInput}
                            />
                            <Calendar className="crm-date-icon" size={16} />
                          </div>
                        </div>
                      </>
                    )}
                    <div className="crm-search-group">
                      <div className="crm-search-input-container">
                        <Search size={16} className="crm-search-icon" />
                        <input
                          type="text"
                          placeholder="Search"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          className="crm-search-input"
                        />
                      </div>
                    </div>

                    <div className="d-flex gap-2 align-items-end">
                      <button
                        className="crm-search-btn"
                        onClick={() => search_data()}
                      >
                        {GuestManagementPageText.Search_text}
                      </button>
                      {/* <button className="crm-show-all-btn">Show All</button> */}
                    </div>
                  </div>
                </div>

                <div className="page_body_container">
                  

                  <div className="table_container">
                    <table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Restaurant Name</th>
                          <th>Mobile Number</th>
                          <th>Email</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody className="trhover">
                        {currentItems.map((option, index) => (
                          <React.Fragment key={option.primary_id}>
                            <tr>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>
                                <div className="rsvnDetails">
                                  <div className="rsvnContactDetails">
                                    <p>{option.restaurant_name}</p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="rsvnDetails">
                                  <div className="rsvnContactDetails">
                                    <p>{option.restaurant_mobile_no}</p>
                                    {option.restaurant_other_no &&
                                      option.restaurant_other_no.length > 2 && (
                                        <p>{option.restaurant_other_no}</p>
                                      )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="rsvnDetails">
                                  <div className="rsvnContactDetails">
                                    <p>{option.restaurant_email}</p>
                                  </div>
                                </div>
                              </td>
                              <td className="th2 tabledata">
                                <div className="actionsAlign">
                                  <div className="guest_incenterActions borderRightRadius  position-relative">
                                    <label className="product-switch">
                                      <input
                                        type="checkbox"
                                        checked={option.active_status}
                                        onClick={() => openModal(option, 1, 1)}
                                      />
                                      <span className="product-slider"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                              <td className="th2 tabledata">
                                <div className="Actionbttns">
                                  <button
                                    className="btn btn-sm btn-info"
                                    onClick={() => viewAccessControl(option)}
                                    style={{ marginRight: "5px" }}
                                  >
                                    <Shield size={16} />
                                  </button>
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => viewSecurityLogs(option)}
                                  >
                                    <Activity size={16} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr style={{ height: "1rem" }}></tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination-container">
                    <Pagination>
                      <Pagination.First
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                      {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      />
                      <Pagination.Last
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                </div>
              </div>
            )}

            {/* ACCESS CONTROL TAB */}
            {activeTab === "access_control" && selectedRestaurant && (
              <div className="page_body">
                <div className="statsCards" style={{ marginBottom: "20px" }}>
                  <div className="statCard">
                    <h4>Total Devices</h4>
                    <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                      {accessStats.total_devices}
                    </p>
                  </div>
                  <div className="statCard">
                    <h4>Total IPs</h4>
                    <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                      {accessStats.total_ips}
                    </p>
                  </div>
                  <div className="statCard">
                    <h4>Active</h4>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "green",
                      }}
                    >
                      {accessStats.active_count}
                    </p>
                  </div>
                  <div className="statCard">
                    <h4>Inactive</h4>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "red",
                      }}
                    >
                      {accessStats.inactive_count}
                    </p>
                  </div>
                </div>

                <div className="filterSection" style={{ marginBottom: "20px" }}>
                  <select
                    value={accessTypeFilter}
                    onChange={(e) => {
                      setAccessTypeFilter(e.target.value);
                      fetchAccessControlList(selectedRestaurant);
                    }}
                    style={{
                      padding: "8px",
                      marginRight: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <option value="all">All Types</option>
                    <option value="device">Device Only</option>
                    <option value="ip">IP Only</option>
                  </select>

                  <select
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      fetchAccessControlList(selectedRestaurant);
                    }}
                    style={{ padding: "8px", borderRadius: "5px" }}
                  >
                    <option value="all">All Status</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <div className="table_container">
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Access Type</th>
                        <th>Access Value</th>
                        <th>Device Name</th>
                        <th>App Name</th>
                        <th>Last Login</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accessControlList.map((access, index) => (
                        <React.Fragment key={access.primary_id}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <span
                                style={{
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    access.access_type === "device"
                                      ? "#e3f2fd"
                                      : "#fff3e0",
                                  color:
                                    access.access_type === "device"
                                      ? "#1976d2"
                                      : "#f57c00",
                                }}
                              >
                                {access.access_type.toUpperCase()}
                              </span>
                            </td>
                            <td>{access.access_value}</td>
                            <td>{access.device_name || "-"}</td>
                            <td>{access.app_name || "-"}</td>
                            <td>{access.last_login || "Never"}</td>
                            <td>
                              <span
                                style={{
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    access.is_active === 1
                                      ? "#c8e6c9"
                                      : "#ffcdd2",
                                  color:
                                    access.is_active === 1
                                      ? "#2e7d32"
                                      : "#c62828",
                                }}
                              >
                                {access.is_active_text}
                              </span>
                            </td>
                            <td>
                              <label className="product-switch">
                                <input
                                  type="checkbox"
                                  checked={access.is_active === 1}
                                  onChange={() => toggleAccessStatus(access)}
                                />
                                <span className="product-slider"></span>
                              </label>
                            </td>
                          </tr>
                          <tr style={{ height: "0.5rem" }}></tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                  {accessControlList.length === 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#999",
                      }}
                    >
                      No access control records found
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* SECURITY LOGS TAB */}
            {activeTab === "security_logs" && selectedRestaurant && (
              <div className="page_body">
                <div className="statsCards" style={{ marginBottom: "20px" }}>
                  <div className="statCard">
                    <h4>Total Logs</h4>
                    <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                      {logStats.total_logs}
                    </p>
                  </div>
                  <div className="statCard">
                    <h4>Allowed</h4>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "green",
                      }}
                    >
                      {logStats.allowed_count}
                    </p>
                  </div>
                  <div className="statCard">
                    <h4>Blocked</h4>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "red",
                      }}
                    >
                      {logStats.blocked_count}
                    </p>
                  </div>
                </div>

                <div className="filterSection" style={{ marginBottom: "20px" }}>
                  <input
                    type="date"
                    value={logDateRange.start}
                    onChange={(e) =>
                      setLogDateRange({
                        ...logDateRange,
                        start: e.target.value,
                      })
                    }
                    style={{
                      padding: "8px",
                      marginRight: "10px",
                      borderRadius: "5px",
                    }}
                  />
                  <input
                    type="date"
                    value={logDateRange.end}
                    onChange={(e) =>
                      setLogDateRange({ ...logDateRange, end: e.target.value })
                    }
                    style={{
                      padding: "8px",
                      marginRight: "10px",
                      borderRadius: "5px",
                    }}
                  />

                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{
                      padding: "8px",
                      marginRight: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="1">Allowed</option>
                    <option value="0">Blocked</option>
                  </select>

                  <select
                    value={accessTypeFilter}
                    onChange={(e) => setAccessTypeFilter(e.target.value)}
                    style={{
                      padding: "8px",
                      marginRight: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <option value="all">All Types</option>
                    <option value="device">Device</option>
                    <option value="ip">IP</option>
                    <option value="both">Both</option>
                  </select>

                  <button
                    onClick={() => fetchSecurityLogs(selectedRestaurant)}
                    className="btn btn-primary"
                    style={{ padding: "8px 20px", borderRadius: "5px" }}
                  >
                    Apply Filters
                  </button>
                </div>

                <div className="table_container">
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Date & Time</th>
                        <th>Access Type</th>
                        <th>Device ID</th>
                        <th>IP Address</th>
                        <th>App Name</th>
                        <th>Endpoint</th>
                        <th>Method</th>
                        <th>Status</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      {securityLogs.map((log, index) => (
                        <React.Fragment key={log.primary_id}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{log.entry_date}</td>
                            <td>
                              <span
                                style={{
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  backgroundColor: "#f5f5f5",
                                }}
                              >
                                {log.access_type.toUpperCase()}
                              </span>
                            </td>
                            <td>
                              {log.device_id ? (
                                <code
                                  style={{
                                    fontSize: "12px",
                                    padding: "2px 5px",
                                    backgroundColor: "#f0f0f0",
                                  }}
                                >
                                  {log.device_id.substring(0, 15)}...
                                </code>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{log.ip_address || "-"}</td>
                            <td>{log.app_name || "-"}</td>
                            <td>
                              <code style={{ fontSize: "12px" }}>
                                {log.endpoint}
                              </code>
                            </td>
                            <td>
                              <span
                                style={{
                                  padding: "3px 8px",
                                  borderRadius: "3px",
                                  backgroundColor: "#e0e0e0",
                                  fontWeight: "bold",
                                  fontSize: "12px",
                                }}
                              >
                                {log.method}
                              </span>
                            </td>
                            <td>
                              <span
                                style={{
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    log.status === 1 ? "#c8e6c9" : "#ffcdd2",
                                  color:
                                    log.status === 1 ? "#2e7d32" : "#c62828",
                                  fontWeight: "bold",
                                }}
                              >
                                {log.status_text}
                              </span>
                            </td>
                            <td>
                              {log.reason ? (
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#666",
                                  }}
                                >
                                  {log.reason}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                          <tr style={{ height: "0.5rem" }}></tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                  {securityLogs.length === 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#999",
                      }}
                    >
                      No security logs found for the selected filters
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal show={showModal} onHide={closeModal} centered backdrop="static">
        <Modal.Body className="modal_body">
          <div className="success_img d-flex justify-content-center"></div>
          <p>
            Are you sure you want to mark{" "}
            <span style={{ color: "#e33745" }}>{clickedButton}</span>
            Restaurant?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="logoutYesBtn"
            onClick={() => confirmVIP(selectedGuestIndex)}
          >
            Yes
          </Button>
          <Button className="logoutNoBtn" onClick={closeModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal2} onHide={closeModal} centered backdrop="static">
        <Modal.Body className="modal_body">
          <div className="w-100 success_img d-flex justify-content-center">
            <select
              id="selectFilter "
              className="input_field_custom5 selectFilter3 w-100 height_padding"
              onChange={handleSelect2}
            >
              {ProductOptions.length > 0 &&
                ProductOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    selected={SelectedData.restaurant_type === option.value}
                  >
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="logoutYesBtn"
            onClick={() => confirmVIP2(selectedGuestIndex, 2)}
          >
            Yes
          </Button>
          <Button className="logoutNoBtn" onClick={closeModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      {showLoaderAdmin && <Loader />}
    </div>
  );
}

export default RestaurantSetup;
